import { render, staticRenderFns } from "./imXLSNewTemp.vue?vue&type=template&id=0d1dc006&scoped=true"
import script from "./imXLSNewTemp.vue?vue&type=script&lang=js"
export * from "./imXLSNewTemp.vue?vue&type=script&lang=js"
import style0 from "./imXLSNewTemp.vue?vue&type=style&index=0&id=0d1dc006&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1dc006",
  null
  
)

export default component.exports